import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import axios from "../../libs/axios";
import useUser from "../../hooks/useUser";
import useAlert from "../../hooks/alerts";
import TableView from "../../components/Table/Table";

function Messages() {
  const [loading, setLoading] = useState(true);
  const { user } = useUser();
  const organization_id =
    user.organizations?.length > 0 && user.organizations[0]?.id;
  const { dispatchAlert } = useAlert();

  const [messages, setMessages] = useState([]);
  const [messagesCreated, setMessagesCreated] = useState([]);

  const getMessages = () => {
    setLoading(true);
    axios.get("/api/v2/me/messages").then((res) => {
      if (res.data.errors) {
        dispatchAlert({
          type: "danger",
          message: res.data.message,
          open: true,
          timeout: 4000,
        });
        return;
      }
      // Handle paginated response: messages.data contains the actual array
      const messagesResponse = res.data.data?.messages ?? res.data.messages;
      const messagesCreatedResponse = res.data.data?.messages_created ?? res.data.messages_created;
      // Extract array from pagination object or use directly if already an array
      const messagesData = messagesResponse?.data ?? messagesResponse;
      const messagesCreatedData = messagesCreatedResponse?.data ?? messagesCreatedResponse;
      setMessages(Array.isArray(messagesData) ? messagesData : []);
      setMessagesCreated(Array.isArray(messagesCreatedData) ? messagesCreatedData : []);
      setLoading(false);
    }).catch((err) => {
      console.error(err);
      setLoading(false);
    });
  };

  useEffect(() => {
    getMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const shortenMessage = (message) => {
    const maxLength = 25;
    if (message.length > maxLength) {
      return message.substring(0, maxLength) + "...";
    }
    return message;
  };

  const messsagesColumns = [
    {
      name: "Property Owner",
    },
    {
      name: "Resident 1",
    },
    {
      name: "Address",
    },
    {
      name: "Message Date",
    },
    {
      name: "Message",
      size: "lg",
    },
  ];

  const formatResident = (caseItem) => {
    if (!caseItem) return "";
    const { residents } = caseItem;
    if (!residents) return "";
    const resident1 = residents[0];
    if (!resident1) {
      return "";
    }
    let addString = "";

    if (resident1.first_name) {
      addString += resident1.first_name;
    }

    if (resident1.last_name) {
      addString += " " + resident1.last_name;
    }

    return addString;
  };

  const messagesRows = messages.map((message, index) => {
    const caseOrgId =
      message.case?.organization_id ?? message.case?.organization?.id;
    return {
      id: message.id,
      endpoint: caseOrgId
        ? `/cases/${message.case.id}/${caseOrgId}?highlight=messages`
        : "",
      api_endpoint: `/organizations/${organization_id}/cases/${message.case_id}/messages/${message.id}`,
      fullRecord: message,
      disabled: !message.case || !caseOrgId,
      columns: [
        {
          display: message.case?.owner?.business_legal_name,
          value: message.case?.owner?.business_legal_name,
        },
        {
          display: formatResident(message.case),
          value: formatResident(message.case),
        },
        {
          display: message.case?.street_address,
          value: message.case?.street_address,
        },
        {
          display: message.sent_at,
          value: message.sent_at,
        },
        {
          display: shortenMessage(message.content),
          value: message.content,
        },
      ],
    };
  });

  const messagesCreatedRows = messagesCreated.map((message, index) => {
    const caseOrgId =
      message.case?.organization_id ?? message.case?.organization?.id;
    return {
      id: message.id,
      endpoint:
        message.case && caseOrgId
          ? `/cases/${message.case.id}/${caseOrgId}?highlight=messages`
          : "",
      api_endpoint: `/organizations/${organization_id}/cases/${message.case_id}/messages/${message.id}`,
      fullRecord: message,
      disabled: !message.case || !caseOrgId,
      columns: [
        {
          display: message.case?.owner?.business_legal_name,
          value: message.case?.owner?.business_legal_name,
        },
        {
          display: formatResident(message.case) || "Case Deleted",
          value: formatResident(message.case),
        },
        {
          display: message.case?.street_address,
          value: message.case?.street_address,
        },
        {
          display: message.sent_at,
          value: message.sent_at,
        },
        {
          display: message.content,
          value: message.content,
        },
      ],
    };
  });

  const sortRowsByDate = (rows) => {
    return rows.sort((a, b) => {
      // sort by date descending
      return new Date(b.fullRecord.sent_at) - new Date(a.fullRecord.sent_at);
    });
  };

  if (loading) {
    return <div className="loader mt-7" />;
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Messages"
          subtitle="Case messages"
          className=""
        />
      </Row>
      <br />

      <Row>
        <Col>
          <TableView
            name="Messages Received"
            columns={messsagesColumns}
            rows={sortRowsByDate(messagesRows)}
            refreshTable={getMessages}
          />
        </Col>
      </Row>
      <br />
      <Row>
        <Col>
          <TableView
            name="Messages Created"
            columns={messsagesColumns}
            rows={sortRowsByDate(messagesCreatedRows)}
            refreshTable={getMessages}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Messages;
